import { i18n } from '@lingui/core';
// Plurals are not included in the compiled scripts for lingui 3.0.0-11+
import { de, en, es, fr, it, pt } from 'make-plural/plurals';
import { messages as deMessages } from '../../locales/de';
import { messages as enMessages } from '../../locales/en';
import { messages as esMessages } from '../../locales/es';
import { messages as frMessages } from '../../locales/fr';
import { messages as itMessages } from '../../locales/it';
// import ptCatalog from '../../locales/pt';

i18n.loadLocaleData('en', { plurals: en });
i18n.loadLocaleData('de', { plurals: de });
i18n.loadLocaleData('it', { plurals: it });
i18n.loadLocaleData('es', { plurals: es });
i18n.loadLocaleData('fr', { plurals: fr });
// i18n.loadLocaleData('pt', { plurals: pt });

export const catalogs = {
  de: { messages: deMessages },
  en: { messages: enMessages },
  it: { messages: itMessages },
  es: { messages: esMessages },
  fr: { messages: frMessages },
  // pt: ensureModule(ptCatalog),
};

export const defaultLocale = 'en';

export const locales = {
  en: 'English',
  de: 'Deutsch',
  it: 'Italiano',
  es: 'Español',
  fr: 'Français',
  // pt: 'Português',
};

export function load(locale) {
  if (!locale) return {};
  const catalog = catalogs[locale];
  i18n.load(locale, catalog.messages);
  return catalog.messages;
}
